export default "__VITE_ASSET__L2w$OEET__"